<template>
  <Timeline
    title="list.name"
    :timeline="timeline"
    :list-id="listId"
    timeline-name="list"
  />
</template>

<script src="./list_timeline.js"></script>
